<template>
  <el-form ref="form" :model="form" :rules="rules" label-width="100px">
    <el-form-item label="负责人">
      <el-select-ex
        ref="sel"
        v-model="curEditItem"
        style="width: 100%"
        url="SystemApplication/ProcedureStep/NotProcedureForUserEntry"
        label-field="fName"
        value-field="fUserID"
        :extra-param="{ key: form.key }"
        sel-first
      />
    </el-form-item>

    <div style="text-align: center">
      <el-button
        type="warning"
        size="small"
        @click="addDirector"
      >添加</el-button>
    </div>
    <el-table :data="tableData">
      <el-table-column prop="key" label="流程步骤标识符" />
      <el-table-column prop="fUserID" label="用户ID" />
      <el-table-column prop="fName" label="名称" />
      <el-table-column label="操作" class-name="table-oper-col">
        <template slot-scope="scope">
          <template>
            <ConfirmButton
              @confirm="delDirector(scope.row)"
            >删除</ConfirmButton>
          </template>
        </template>
      </el-table-column>
    </el-table>
  </el-form>
</template>

<script>
import ConfirmButton from '@components/ConfirmButton'

export default {
  components: {
    ConfirmButton
  },
  props: {
    form: Object,
    canAdd: Boolean,
    canDel: Boolean
  },
  data: function() {
    return {
      curEditItem: '',
      rules: {},
      tableData: []
    }
  },
  computed: {
    isEdit: function() {
      return !!this.form.fRegionID
    }
  },
  mounted: function() {
    this.refresh()
  },
  methods: {
    refresh: function() {
      this.$httpPost('SystemApplication/ProcedureStep/ProcedureForUserEntry', {
        key: this.form.key
      }).then((res) => {
        this.tableData = res.datalist
      })
    },

    addDirector: function() {
      this.postData('Add', {
        key: this.form.key,
        fUserID: this.curEditItem
      })
    },

    delDirector: function(row) {
      this.postData('Delete', {
        key: row.key,
        fUserID: row.fUserID
      })
    },

    postData: function(type, data) {
      return this.$httpPost(
        `SystemApplication/ProcedureStep/ProcedureForUser${type}`,
        data
      ).then(async(res) => {
        if (res.isSuccess) {
          this.$message.success(res.message)
          this.$refs.sel.refresh()
          this.refresh()
          this.curEditItem = null
          // console.log(this.$refs, " this.$refs");
        } else {
          this.$message.error(res.message)
          throw res.message
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
</style>
